/* eslint-disable react-hooks/refs */
import { useCallback, useRef, DependencyList } from 'react'

const useEvent = <T extends (...args: never[]) => unknown>(callback: T, deps: DependencyList = []): T => {
  const ref = useRef(callback)
  ref.current = callback

  // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
  return useCallback((...args: Parameters<T>) => ref.current(...args), deps) as T
}

export default useEvent
